// extracted by mini-css-extract-plugin
module.exports = {"ElectrificationItem":"ElectrificationListItem_ElectrificationItem__1DAB9","ElectrificationItemEnumName":"ElectrificationListItem_ElectrificationItemEnumName__3VUoS"};